import { Box, Typography } from '@mui/material';

import { Tag } from '@/components/Tag';

type SelectWidgetProps = {
  icon?: React.ReactNode;
  title: string;
  description?: string;
  onSelect: () => void;
  soon?: boolean;
  testId?: string;
};

const SelectWidget = ({
  icon,
  title,
  description,

  onSelect,
  soon = false,
  testId
}: SelectWidgetProps) => {
  return (
    <Box
      data-testid={testId}
      sx={{
        backgroundColor: 'background.paper',
        display: 'flex',
        gap: 1.5,
        padding: 2,
        cursor: soon ? 'normal' : 'pointer',
        flexDirection: 'column',
        position: 'relative'
      }}
      onClick={soon ? () => {} : onSelect}
    >
      {soon && (
        <Box
          data-testid='widget-soon'
          sx={{
            position: 'absolute',
            top: 16,
            right: 16
          }}
        >
          <Tag label='Coming Soon' />
        </Box>
      )}
      <Box
        data-testid='widget-icon'
        sx={{
          fontSize: '20px',
          display: 'flex',
          gap: 1,
          alignItems: 'center'
        }}
      >
        {icon}
        <Typography
          component='div'
          data-testid='widget-title'
          sx={{
            fontWeight: 700,

            gap: 2,
            display: 'inline-flex',
            alignItems: 'center'
          }}
        >
          {title}
        </Typography>
      </Box>
      <Box>
        {description && (
          <Box
            data-testid='widget-description'
            sx={{ color: 'text.secondary', fontSize: 14 }}
          >
            {description}
          </Box>
        )}
      </Box>
    </Box>
  );
};
export default SelectWidget;
